'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var PropTypes = require('prop-types');
var PaginationButton = require('./PaginationButton.js');
var usePagination = require('../../utilities/hooks/usePagination.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Pagination = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var data = _ref.data,
    pageSize = _ref.pageSize,
    onPageChange = _ref.onPageChange,
    scrollId = _ref.scrollId;
  var _useState = React.useState(1),
    _useState2 = slicedToArray.default(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  React.useEffect(function () {
    var _data$slice;
    var firstPageIndex = (currentPage - 1) * pageSize;
    var lastPageIndex = firstPageIndex + pageSize;
    onPageChange((_data$slice = data === null || data === void 0 ? void 0 : data.slice(firstPageIndex, lastPageIndex)) !== null && _data$slice !== void 0 ? _data$slice : []);
  }, [currentPage]);
  var paginationRange = usePagination.usePagination(currentPage, pageSize, data.length);
  var lastPage = paginationRange[paginationRange.length - 1];
  React.useImperativeHandle(ref, function () {
    return {
      setCurrentPage: setCurrentPage,
      currentPage: currentPage,
      lastPage: lastPage
    };
  });
  var nextPage = function nextPage() {
    setCurrentPage(currentPage + 1);
  };
  var previousPage = function previousPage() {
    setCurrentPage(currentPage - 1);
  };
  if (paginationRange.length < 2) {
    return null;
  }
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: "pagination",
    "data-testid": "lanl-pagination"
  }, currentPage !== 1 && /*#__PURE__*/React__default.default.createElement(PaginationButton.PaginationButton, {
    text: "Previous",
    onClick: previousPage,
    scrollId: scrollId
  }), paginationRange.map(function (pageNumber, index) {
    return /*#__PURE__*/React__default.default.createElement(PaginationButton.PaginationButton, {
      key: "pagination-page-".concat(index),
      text: pageNumber,
      active: currentPage === pageNumber,
      onClick: function onClick() {
        return setCurrentPage(pageNumber);
      },
      scrollId: scrollId
    });
  }), currentPage !== lastPage && /*#__PURE__*/React__default.default.createElement(PaginationButton.PaginationButton, {
    text: "Next",
    onClick: nextPage,
    scrollId: scrollId
  }));
});
Pagination.displayName = 'Pagination';
Pagination.defaultProps = {
  data: [],
  pageSize: 10,
  onPageChange: function onPageChange() {}
};
Pagination.propTypes = {
  data: PropTypes__default.default.array,
  onPageChange: PropTypes__default.default.func,
  pageSize: PropTypes__default.default.number
};

exports.Pagination = Pagination;
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map
